/**
 * 数据请求的唯一入口
 * 官网前台只依赖 home 模块；shop / user 是从别的项目抄来的死接口，已删除。
 */
import home from './modules/home.js';

export default {
    home
}
